import styled from 'styled-components'

const TableTitle = styled.h6`
  color: #6b6868;
  font-size: 1.1rem;
`
export default TableTitle
